'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Translation = undefined;

var _reactIntl = require('react-intl');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Translation = (0, _reactIntl.injectIntl)(function (_ref) {
    var intl = _ref.intl,
        values = _ref.values,
        messageDescriptor = _objectWithoutProperties(_ref, ['intl', 'values']);

    return intl.formatMessage(messageDescriptor, values);
});

exports.Translation = Translation;